import { Reveal, SectionLabel } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "Was kostet eine Website bei dir?",
    a: "Das hängt vom Umfang ab — ein Onepager kostet weniger als eine Website mit sechs Unterseiten und Online-Terminbuchung. Im kostenlosen Erstgespräch bekommst du einen Festpreis, der genau so bleibt. Keine versteckten Kosten, keine Überraschungen auf der Rechnung.",
  },
  {
    q: "Wie lange dauert es, bis meine Website online ist?",
    a: "In der Regel 2–4 Wochen vom Erstgespräch bis zum Launch. Ein Onepager geht oft schneller. Du bekommst zu Beginn einen klaren Zeitplan und regelmäßig Zwischenstände.",
  },
  {
    q: "Ich habe keine Texte und keine Fotos. Ist das ein Problem?",
    a: "Nein — das ist der Normalfall. Ich schreibe die Texte für dich, so dass sie deine Kunden verstehen und Google sie findet. Für Fotos finden wir gemeinsam eine Lösung, von professionellen Aufnahmen bis zu hochwertigem Bildmaterial.",
  },
  {
    q: "Muss ich mich nach dem Launch selbst um die Seite kümmern?",
    a: "Nur wenn du willst. Mit dem Rundum-sorglos-Paket übernehme ich Updates, Sicherheit und Änderungen komplett — du schreibst mir einfach eine E-Mail. Alternativ zeige ich dir, wie du kleine Änderungen selbst machst.",
  },
  {
    q: "Ist die Website DSGVO-konform?",
    a: "Ja, immer. Impressum, Datenschutzerklärung, Cookie-Handling und datenschutzfreundliche Technik gehören bei mir zum Standard — nicht zum Aufpreis.",
  },
  {
    q: "Was passiert im kostenlosen Erstgespräch?",
    a: "Wir telefonieren etwa 20 Minuten. Du erzählst von deinem Betrieb, ich schaue mir deine aktuelle Situation an und sage dir ehrlich, was sich lohnt — und was nicht. Danach entscheidest du in Ruhe. Kein Verkaufsdruck, versprochen.",
  },
];

export default function FAQ() {
  return (
    <section className="py-20 md:py-32">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <Reveal>
          <SectionLabel number="07" label="Häufige Fragen" />
          <h2 className="font-display font-medium text-3xl md:text-4xl lg:text-5xl tracking-tight">
            Alles, was du vorher wissen willst.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="mt-12">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="border-[#E4E4E7]">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display font-medium text-base md:text-lg hover:text-[#2563EB] hover:no-underline py-6"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#52525B] leading-relaxed text-[15px] pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
